export function MegaphoneIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.5 8.125V11.875C2.5 12.2202 2.77982 12.5 3.125 12.5H5L5.625 12.5V7.5L5 7.5H3.125C2.77982 7.5 2.5 7.77982 2.5 8.125Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 7.5L15.3287 3.45471C15.7405 3.28309 16.1946 3.58567 16.1946 4.03186V15.9681C16.1946 16.4143 15.7405 16.7169 15.3287 16.5453L5.625 12.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 12.9167V15.625C6.875 16.3154 7.43464 16.875 8.125 16.875H8.75C9.44036 16.875 10 16.3154 10 15.625V14.2188"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
